import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { callable } from 'src/app/components/callable';

@Injectable({
  providedIn: 'root'
})
export class CoopServiceService {

  path = environment.apiUrl2;
  // path = 'http://61.19.210.103:456/';

  constructor(private http: HttpClient) { }

  GetKhetList(): Observable<any> {

    let URL = this.path + 'api/CoopProfile/GetKhetList';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetPhakList(): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetPhakList';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetProvinceByKhet(KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetProvinceByKhet';

    let body = {
      KhetId: KhetId
    }
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.post(URL, body);
  }

  GetProvinceList(): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetProvinceList';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetPhakByKhet(KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetPhakByKhet';
    let body = {
      KhetId: KhetId
    }
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.post(URL, body);
  }

  GetCoopStatusSumYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopStatusSumYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetCoopList(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopList';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }

    return this.http.post(URL, body);
  }

  GetStandardYear(): Observable<any> {
    let URL = this.path + 'api/StandardData/GetStandardYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoopStatusSumYearAll(): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopStatusSumYearAll';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoopMemberYearDataSum(datayear: string): Observable<any> {

    let URL = this.path + 'api/Member/GetCoopMemberYearDataSum';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetCoopSumCommittee(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopCommittee/GetCoopSumCommitteeNew';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }

    return this.http.post(URL, body);
  }

  GetCoopAgeYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopAgeYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetCoopRegisterQiutYear(): Observable<any> {
    let URL = this.path + 'api/StandardData/GetCoopRegisterQiutYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetAssetUseItemYear(PurchaseYear: string): Observable<any> {
    let URL = this.path + 'api/Asset/GetAssetUseItemYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      PurchaseYear: PurchaseYear
    }

    return this.http.post(URL, body);
  }

  GetCoopEndmonthYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopEndmonthYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetCoopStatusProvinceYearOne(DataYear: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopStatusProvinceYearOne';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetProductRubberYearProduct(DataType: string): Observable<any> {
    let URL = this.path + 'api/Product/GetProductRubberYearProduct';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataType: DataType
    }

    return this.http.post(URL, body);
  }

  GetCoopStatusSumYearCategoryAll(): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopStatusSumYearCategoryAll';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }


  GetCoopCommitteeProvinceYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/CoopCommittee/GetCoopCommitteeProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetDistinctAssetYear(): Observable<any> {
    let URL = this.path + 'api/Asset/GetDistinctAssetYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetAssetUseYear(PurchaseYear: string): Observable<any> {
    let URL = this.path + 'api/Asset/GetAssetUseYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      PurchaseYear: PurchaseYear
    }

    return this.http.post(URL, body);
  }

  GetCoopManagerYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopManagerYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetCoopOfficerYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopOfficerYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetCoopEndmonthYearDistinct(): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopEndmonthYearDistinct';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetDistinctBusinessProvinceYear(): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetDistinctBusinessProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoopBusinessYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetCoopBusinessEachProvince(DataYear: string, OrgOrgId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessEachProvince';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear,
      OrgOrgId: OrgOrgId
    }

    return this.http.post(URL, body);

  }

  GetCoopMemberProvinceYears(DataYear: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberProvinceYears';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);

  }

  GetCoopMemberSumMFm(): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberSumMFm';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }


  GetCoopMemberYearData(DataYear: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberYearData';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);

  }

  GetCoopFederationProvinceYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopFederationProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);

  }

  GetCoopFederationYearSumType(): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopFederationYearSumType';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCoopFederationYearByType(DataYear: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopFederationYearByType';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);

  }

  GetLastestProfile(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetLastestProfile/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCoopMemberItemYearByCoopId(coopId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberItemYearByCoopId';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      coopId: coopId
    }

    return this.http.post(URL, body);

  }

  GetCommitteeItemYearByCoopId(coopId: string): Observable<any> {
    let URL = this.path + 'api/CoopCommittee/GetCommitteeItemYearByCoopId';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      coopId: coopId
    }

    return this.http.post(URL, body);

  }

  GetCpdRiceYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCpdRiceYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCpdRubberYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCpdRubberYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCpdOaeYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCpdOaeYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetAssetYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAssetYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetMachinesByRegister(coopId: string): Observable<any> {
    let URL = this.path + 'api/Machine/GetMachinesByRegister/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCollectYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCollectYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    return this.http.get(URL);

  }


  GetCoopBusinessLastest(coopId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessLastest';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      coopId: coopId
    }

    return this.http.post(URL, body);

  }

  GetCoopAgeYearDistinctYear(): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopAgeYearDistinctYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetDistinctCommitteeYear(): Observable<any> {
    let URL = this.path + 'api/CoopCommittee/GetDistinctCommitteeYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCoopStatusProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopStatusProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopStandardProvinceYearByYear(DataYear: string): Observable<any> {
    let URL = this.path + 'api/StandardData/GetCoopStandardProvinceYearByYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }
    return this.http.post(URL, body);

  }

  GetCoopStandardProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/StandardData/GetCoopStandardProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopMemberEachProvinceLastestYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberEachProvinceLastestYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopFederationEachProvinceLastestYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopFederationEachProvinceLastestYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopCommiteeProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopCommittee/GetCoopCommiteeProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopStandardYearAll(): Observable<any> {
    let URL = this.path + 'api/StandardData/GetCoopStandardYearAll';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCoopBusinessMap(DataYear: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessMap';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetRubberDistributorTypeYear(): Observable<any> {
    let URL = this.path + 'api/Product/GetRubberDistributorTypeYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  // รวบรวม

  GetRubberSumProductYear(): Observable<any> {
    let URL = this.path + 'api/Product/GetRubberSumProductYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  // จำหน่าย

  GetRubberSumDistributorYear(): Observable<any> {
    let URL = this.path + 'api/Product/GetRubberSumDistributorYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  // รวบรวม
  GetRubberProductProvinceYear(): Observable<any> {
    let URL = this.path + 'api/Product/GetRubberProductProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCoopEndmonthProvinceYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopEndmonthProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopBusinessMapBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessMapBySearch';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopMachineYear(AgriPurchaseYear: string): Observable<any> {
    let URL = this.path + 'api/Machine/GetCoopMachineYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      AgriPurchaseYear: AgriPurchaseYear
    }
    return this.http.post(URL, body);

  }


  // จัดจำหน่าย
  GetRubberDistributorProvinceYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Product/GetRubberDistributorProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetRubberProductProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Product/GetRubberProductProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopBusinessTypeProvinceYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessTypeProvinceYear';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopStatusTypeProvinceYearLastest(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopStatusTypeProvinceYearLastest';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  // เพิ่มมาใหม่
  //ค้นหาชื่อสหกรณ์
  GetCoopProfileAll(CoopNameTh: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopProfileAll';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    let body = {
      CoopNameTh: CoopNameTh
    }
    return this.http.post(URL, body);

  }

  GetCoopOracleCountNEW(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopOracleCountNEW';
    // URL = callable.setPathParam(URL);
    // URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopLevelCount(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopLevelCountNEW';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopOracleTypes(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopOracleTypesNEW';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopFinance(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopFinanceNew';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopFinanceType(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopFinanceTypeNew';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopBussiness(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopBussinessNew';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopBussinessType(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopBussinessTypeNew';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopProfileBussiness(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopProfileBussinessNew';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopProfileBussinessType(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopProfileBussinessTypeNew';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopSumOfficer(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopSumOfficer';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopSumMember(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopSumMemberNew';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetOracleSumProvinceYearSearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetOracleSumProvinceYearSearch';
    // URL = callable.setPathParam(URL);
    // URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopMemberProvinceYearSearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberProvinceYearSearch';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetBussinessProvinceYearSum(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetBussinessProvinceYearSum';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopDefect(CoopId: string): Observable<any> {
    let URL = this.path + 'api/Defect/GetCoopDefect';
    // URL = callable.setPathParam(URL);
    // URL = callable.setPathParamSector(URL);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }

  GetCoopBusinessFiveYears(CoopId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopBusinessFiveYears';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }

  GetCoopProfileBussinessFiveYears(CoopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopProfileBussinessFiveYears';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }


  GetCoopTypeLevelCount(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetCoopTypeLevelCount';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetFinanceFiveYears(CoopId: string): Observable<any> {
    let URL = this.path + 'api/Finance/GetFinanceFiveYears';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }

  GetCoopStandardTypeSum(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/StandardData/GetCoopStandardTypeSum';


    URL = callable.setPathParam(URL);
    console.log('URLURLURL',URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopAssetByCoopId(CoopInfoCoopId: any): Observable<any> {
    let URL = this.path + 'api/Asset/GetCoopAssetByCoopId';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      CoopInfoCoopId: CoopInfoCoopId
    }
    return this.http.post(URL, body);

  }

  GetCoopMachineByCoopId(CoopInfoCoopId: any): Observable<any> {
    let URL = this.path + 'api/Machine/GetCoopMachineByCoopId';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      CoopInfoCoopId: CoopInfoCoopId
    }
    return this.http.post(URL, body);

  }

  GetCoopAssetDesc(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Asset/GetCoopAssetDesc';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopMachineSumDesc(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Machine/GetCoopMachineSumDesc';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopViewRiceOracleSumYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopViewRiceOracleSumYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);

  }

  GetCoopViewRubberOracleSumYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopViewRubberOracleSumYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL,true);
    return this.http.get(URL);

  }

  GetCoopViewOaeOracleSumYear(coopId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetCoopViewOaeOracleSumYear/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL, true);
    return this.http.get(URL);

  }

  GetDefectProvinceYearSum(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Defect/GetDefectProvinceYearSum';
    // URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetProvinceByCoopId(CoopId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetProvinceByCoopId';
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }

  GetViewOAEByGroup(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/View/GetViewOAEByGroup';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetViewRubberSumProvinceTotal(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/View/GetViewRubberSumProvinceTotal';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetViewOAEDetailByGroup(OrgOrgId: string, PhakId: string, KhetId: string, group_id): Observable<any> {
    let URL = this.path + 'api/View/GetViewOAEDetailByGroup';
    URL = callable.setPathParam(URL, true);
    URL = callable.setPathParamSector(URL);
    let body = {
      groupCode: group_id,
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetCoopmk_good(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoopmk_good/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoop_memberzone(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoop_memberzone/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoop_Reportbalance(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoop_Reportbalance/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoop_ReportBussinessProfile(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoop_ReportBussinessProfile/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoop_ReportProfileBussiness(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoop_ReportProfileBussiness/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoop_ReportOae(coopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetCoop_ReportOae/' + coopId;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    return this.http.get(URL);
  }

  GetCoop_Report_Cael(size_member: any, size_netasset: any, org_org_id: any): Observable<any> {
    let URL = this.path + `api/ProfileData/GetCoop_Report_Cael`;
    URL = callable.setPathParam(URL);
    URL = callable.setPathParamSector(URL);
    URL = URL + `&size_member=${size_member}&size_netasset=${size_netasset}&org_org_id=${org_org_id}`
    return this.http.get(URL);
  }

}
